import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useConfig } from '../../contexts/config-context';
import Fieldset from '../fieldset';
import styles from './appointment-field.scss';
import { DatePicker } from './datepicker';
import { Text } from 'wix-ui-tpa/cssVars';
import { TimeSlots } from './slots';
import useInitialAppointmentState from './actions/initialAppointmentState';
export function AppointmentField(_ref) {
  let {
    onBlur,
    onFocus,
    inputId,
    ariaLabelledBy,
    ariaDescribedBy
  } = _ref;
  const {
    isMobile
  } = useConfig();
  const [appointmentState, setAppointmentState] = useState(null);
  const initialAppointmentState = useInitialAppointmentState();
  useEffect(() => {
    setAppointmentState(initialAppointmentState);
  }, [initialAppointmentState]);

  // TODO: use appointmentState as props to child components when its ready
  // eslint-disable-next-line no-console
  console.log(appointmentState);
  return /*#__PURE__*/React.createElement(Fieldset, {
    id: inputId,
    onFocus: onFocus,
    onBlur: onBlur,
    ariaLabelledBy: ariaLabelledBy,
    className: classNames(styles.fields, {
      [styles.mobile]: isMobile
    }),
    ariaDescribedBy: ariaDescribedBy,
    required: true
  }, /*#__PURE__*/React.createElement(DatePicker, null), /*#__PURE__*/React.createElement("div", {
    className: styles.textRegion
  }, /*#__PURE__*/React.createElement(Text, {
    tagName: "p"
  }, "Timezone: Jerusalem (GMT +2)"), /*#__PURE__*/React.createElement(Text, {
    tagName: "p"
  }, "Phone call")), /*#__PURE__*/React.createElement(TimeSlots, null));
}
//# sourceMappingURL=appointment.js.map